import React from "react";

import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

export default function EnhancedTableHead(props) {
  const { order, orderBy, onSort } = props;

  return (
    <TableHead>
      <TableRow>
        <TableCell
          style={{
            position: "sticky",
            top: 0,
            left: 0,
            zIndex: 11,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>Run Name</span>
            <SortingIcon
              order={order}
              active={orderBy === "runname"}
              onClick={() => onSort("runname")}
            />
          </div>
        </TableCell>
        <TableCell>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>Job ID</span>
            <SortingIcon
              order={order}
              active={orderBy === "id"}
              onClick={() => onSort("id")}
            />
          </div>
        </TableCell>
        <TableCell>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>Run Type</span>

            <SortingIcon
              order={order}
              active={orderBy === "runtype"}
              onClick={() => onSort("runtype")}
            />
          </div>
        </TableCell>
        <TableCell>
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>Date</span>

            <SortingIcon
              order={order}
              active={orderBy === "date"}
              onClick={() => onSort("date")}
            />
          </div>
        </TableCell>
        <TableCell>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              minWidth: "219px"
            }}
          >
            <span className="storage-limit" style={{ marginRight: "8px" }}>Parameters</span>

            <SortingIcon
              order={order}
              active={orderBy === "parameter"}
              onClick={() => onSort("parameter")}
            />
          </div>
        </TableCell>
        <TableCell align="center">
            <span className="storage-limit" style={{ marginRight: "8px" }}>Size</span>
        </TableCell>
        <TableCell align="center"><span className="storage-limit" style={{ marginRight: "8px"}}>Status</span></TableCell>
        <TableCell align="center"><span className="storage-limit" style={{ marginRight: "8px" }}>Actions</span></TableCell>
      </TableRow>
    </TableHead>
  );
}

function SortingIcon({ order, active, onClick }) {
  return (
    <span
      onClick={onClick}
      style={{
        cursor: "pointer",
        display: "inline-flex",
        flexDirection: "column",
        //   alignItems: "center",
        //   marginLeft: "5px",
      }}
    >
      <span
        style={{
          color: active && order === "asc" ? "#000" : "#ccc",
          fontSize: "0.5rem",
          lineHeight: "0.5rem",
        }}
      >
        ▲
      </span>
      <span
        style={{
          color: active && order === "desc" ? "#000" : "#ccc",
          fontSize: "0.5rem",
          lineHeight: "0.5rem",
        }}
      >
        ▼
      </span>
    </span>
  );
}
